import { useAuth } from '@/auth/AuthContext'
import { can } from '@/auth/access'
import { VenueDangerZone } from '@/components/VenueDangerZone'
import type { VenueDto } from '@lib/dto/venue.dto'

/**
 * The organization's decisions about a venue: whether it stays. Rendered only
 * for staff working across the company — see `atCompanyLevel`, and the caller
 * that checks it — and each part only for those whose role allows it. Who works
 * at the venue is its own Staff section, which its own staff may see too.
 *
 * Deliberately does *not* include event tracks. Tracks are how this venue runs
 * its own events, so they belong to the venue and stay visible inside it; what
 * may be deleted wholesale does not, which is why they are not in the same pane.
 */
export function VenueOrganizationSettings({ venue }: { venue: VenueDto }) {
  const { user } = useAuth()
  return (
    <div className="space-y-8">
      <VenueDangerZone
        venue={venue}
        canClearEvents={can(user, 'deleteEvents') && can(user, 'events:edit')}
        canDelete={can(user, 'venues:edit')}
      />
    </div>
  )
}
